<template>
  <div class="container mt-5">
    <vs-breadcrumb :items="[
        { title: 'Seguridad', url: '/security' },
        { title: 'Navegación', url: '/security/navigation' },
        { title: 'Menú', active: true }
    ]"></vs-breadcrumb>
    <vx-card
      :title="menuItemSelected === null ? 'Configuración de menú': `Configuración de menú '${menuItemSelected.text}'`"
      subtitle="Puede arrastrar los elementos principales para cambiar el orden en que se presentan.">
      <slot name="content">
        <div class="row">
          <div class="col-md-4">
            <menu-item-list
              :menuItemSelected="menuItemSelected"
              @onClickItemMenu="clickMenuItemHandler"
              :menu-id="menu.id"
              :items="menu.items"></menu-item-list>
          </div>

          <div class="inputs col-md-4 offset-md-2">
            <vx-card title="Editar elemento de menú" v-if="menuItemSelected !== null">
              <menu-item-form
                @onCancelEdition="menuItemSelected = null"
                :roles="roles"
                :menuItemSelected="menuItemSelected"
                @onAddItem="addItem"
              ></menu-item-form>
            </vx-card>

            <vx-card title="Crear elemento" v-else>
              <menu-item-create-form
                :menu-id="menu.id"
                :roles="roles"
                @onAddItem="addItem"
              ></menu-item-create-form>
            </vx-card>
          </div>
        </div>
      </slot>
    </vx-card>
  </div>
</template>

<script>
import {Menu, NavigationService} from "@/models/Menu/NavigationService";
import MenuItemList from "@views/admin/backoffice-nav-management/MenuItemList.vue";
import MenuItemForm from "@views/admin/backoffice-nav-management/MenuItemForm.vue";
import MenuItemCreateForm from "@views/admin/backoffice-nav-management/MenuItemCreateForm.vue";

export default {
  name: "MenuConfig",
  components: {MenuItemCreateForm, MenuItemForm, MenuItemList},
  data: () => ({
    menu: new Menu(1, "Menu", "Hello Wor0ld"),
    menuItemSelected: null,
    roles: [],
  }),
  watch: {
    menuItemSelected: async function () {
      await this.main();
    }
  },
  async mounted() {
    this.$vs.loading();
    try {
      await this.main()
    } finally {
      this.$vs.loading.close();
    }
  },
  methods: {
    async main() {
      let parentId = null;
      if(this.menuItemSelected !== null) {
        parentId = this.menuItemSelected.id
      }

      this.menu = await NavigationService.find(this.$route.params.menuId, parentId);

      if(this.$route.params.menuItemId) {
        this.menuItemId = this.$route.params.menuItemId;
      }

      const { data } = await axios.get('/api/roles')
      this.roles = data;
    },
    clickMenuItemHandler(e) {
      this.menuItemSelected = e;
    },
    async addItem(menuItem) {
      menuItem.menuId = this.menu.id;
      this.menu.items.push(menuItem)
    }
  }
}
</script>

<style scoped>

</style>
